import React, { useEffect, useRef, useState } from "react";
import PartIIStyle from "./partii.module.css";
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  Table,
  Carousel,
  Tooltip,
  Popover 
} from "antd";
import {SelectOPtions,methy_compare_info} from "../../json/compareSelect";
import DNA2Colums from "../../json/DNA2Colums";
import methy_compare_DMR_paths from "../../json/methy_compare_DMR_paths";
import methy_DMR_GO_paths from "../../json/methy_DMR_GO_paths";
import methy_DMR_KEGG_paths from "../../json/methy_DMR_KEGG_paths";
import http from "../../../../utils/http";
import styled from "styled-components";
import { Part_iSelectOptions } from "../../../../assets/json/Epigenome/methylation_summary";
const {TextArea} = Input;
const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    background-color: #e3f2d9; // 修改表头背景颜色
    color: #333; // 修改表头文字颜色
    font-weight: bold; // 修改表头文字加粗
  }
`;

const StyledCarousel = styled(Carousel)`
  .slick-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 400px;
  }

  .carousel-item {
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  img {
    max-width: 100%;
  }
`;
const StyledCarouselKEGG = styled(Carousel)`
  .slick-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 500px;
  }

  .carousel-item {
    width: 100%;
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  img {
    max-width: 100%;
  }
`;

function Part_II() {
  const [form] = Form.useForm();
  const [pages, setPages] = useState(1);
  const [PageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [CompareTable, setCompareTable] = useState([]);
  const [Part_IIImg, setPart_IIImg] = useState({});
  const [formValues, setFormValues] = useState({}); // 存储表单的值
  const [defaultVariety, setDefaultVariety] = useState("CA9DAP_vs_ZY9DAP"); // 默认选择的 compare_varietys
  // 获取数据的函数
  const GetPartII = (values, pages, PageSize) => {
    const compareVarieties = values?.compare_varietys || defaultVariety; // 如果没有传 compare_varietys，则使用默认值
    http
      .get(
        `/api/methy/dmr/?compare_varietys=${compareVarieties}&page=${pages}&page_size=${PageSize}`
      )
      .then((res) => {
        setTotal(res.count);

        setCompareTable(res.results);
        setPart_IIImg(methy_compare_DMR_paths[compareVarieties]);
      })
      .catch((err) => {});
  };

  // 在分页时刷新数据
  useEffect(() => {
    if (formValues?.compare_varietys) {
      GetPartII(formValues, pages, PageSize);
      setPart_IIImg(methy_compare_DMR_paths[formValues.compare_varietys]);
    } else {
      GetPartII({ compare_varietys: defaultVariety }, pages, PageSize); // 默认请求数据
      setPart_IIImg(methy_compare_DMR_paths[defaultVariety]);
    }
  }, [pages, PageSize]);

  // 分页配置
  const paginationConfig = {
    current: pages,
    pageSize: PageSize,
    total: total,
    showSizeChanger: true,
    pageSizeOptions: ["10", "25", "50", "100"],
    onChange: (page) => {
      setPages(page);
    },
    onShowSizeChange: (current, size) => {
      setPageSize(size);
      setPages(1); // Reset to first page on page size change
    },
  };

  const SwiperBoxPlot = useRef(null);
  const SwiperCircos = useRef(null);
  const SwiperDistribution = useRef(null);
  const SwiperHeatMap = useRef(null);
  const SwiperRefFn = (name) => {
    if (name == "boxplot") {
      return SwiperBoxPlot;
    }
    if (name == "circos") {
      return SwiperCircos;
    }
    if (name == "distribution") {
      return SwiperDistribution;
    }
    if (name == "heatmap") {
      return SwiperHeatMap;
    }
  };
  const [selectedIndexOne, setSelectedIndexOne] = useState(0); // 用来存储选中的图片索引
  const [selectedIndexTwo, setSelectedIndexTwo] = useState(0); // 用来存储选中的图片索引
  const [selectedIndexThree, setSelectedIndexThree] = useState(0); // 用来存储选中的图片索引
  const [selectedIndexFour, setSelectedIndexFour] = useState(0); // 用来存储选中的图片索引
  const selectedIndexFn = (name, index) => {
    if (name == "boxplot") {
      return selectedIndexOne == index ? "2px solid #BDF7C1" : "2px solid #fff";
    }
    if (name == "circos") {
      return selectedIndexTwo == index ? "2px solid #BDF7C1" : "2px solid #fff";
    }
    if (name == "distribution") {
      return selectedIndexThree == index
        ? "2px solid #BDF7C1"
        : "2px solid #fff";
    }
    if (name == "heatmap") {
      return selectedIndexFour == index
        ? "2px solid #BDF7C1"
        : "2px solid #fff";
    }
  };
  /* Go */
  const GoSwiperRef = useRef(null);
  const GoSwiperChange = (index) => {
    return index == GoSwiperCurrent ? "2px solid #BDF7C1" : "2px solid #fff";
  };
  const [GoPage, setGoPage] = useState(1);
  const [GoPageSize, setGoPageSize] = useState(10);
  const [GoTotal, setGoTotal] = useState(0);
  const [GoTable, setGoTable] = useState([]);
  const [GoColumn, setGoColumn] = useState([]);
  const [GoImgList, setGoImgList] = useState([]);
  const [GoSwiperCurrent, setGoSwiperCurrent] = useState(0);
  const GetGoPartII = (values, go_pages, go_page_size) => {
    setGoImgList(methy_DMR_GO_paths[values.compare_varietys]);
    http
      .get(
        `/api/methy/dmr/go/?compare_varietys=${values.compare_varietys}&go_page=${go_pages}&go_page_size=${go_page_size}`
      )
      .then((res) => {
        setGoTotal(res.count);
        let TempleColumsGo = [];
        Object.keys(res.results[0]).map((key) => {
          console.log(key);
          TempleColumsGo.push({
            key: key,
            title: key,
            dataIndex: key,
            align: "center",
          });
        });
        setGoColumn(TempleColumsGo);
        setGoTable(res.results);
        setIsSubmitLoading(false);
      })
      .catch((err) => {
        setIsSubmitLoading(false);
      });
  };

  useEffect(() => {
    if (formValues?.compare_varietys) {
      GetGoPartII(formValues, GoPage, GoPageSize);
      setGoImgList(methy_DMR_GO_paths[formValues.compare_varietys]);
    } else {
      GetGoPartII({ compare_varietys: defaultVariety }, GoPage, GoPageSize); // 默认请求数据
      setGoImgList(methy_DMR_GO_paths[defaultVariety]);
    }
  }, [GoPage, GoPageSize]);
  const paginationConfigGo = {
    current: GoPage,
    pageSize: GoPageSize,
    total: GoTotal,
    showSizeChanger: true,
    pageSizeOptions: ["10", "25", "50", "100"],
    onChange: (page) => {
      setGoPage(page);
    },
    onShowSizeChange: (current, size) => {
      console.log(size)
      setGoPageSize(size);
      setGoPage(1); // Reset to first page on page size change
    },
  };

  /* KEGG */
  const KEGGSwiperRef = useRef(null);
  const KEGGSwiperChange = (index) => {
    return index == KEGGSwiperCurrent ? "2px solid #BDF7C1" : "2px solid #fff";
  };
  const [KEGGPage, setKEGGPage] = useState(1);
  const [KEGGPageSize, setKEGGPageSize] = useState(10);
  const [KEGGTotal, setKEGGTotal] = useState(0);
  const [KEGGTable, setKEGGTable] = useState([]);
  const [KEGGColumn, setKEGGColumn] = useState([]);
  const [KEGGImgList, setKEGGImgList] = useState([]);
  const [KEGGSwiperCurrent, setKEGGSwiperCurrent] = useState(0);
  const [IsSubmitLoading, setIsSubmitLoading] = useState(false);

  const GetKEGGPartII = (values, kegg_pages, kegg_page_size) => {
    setKEGGImgList(methy_DMR_KEGG_paths[values.compare_varietys]);
    http
      .get(
        `/api/methy/dmr/kegg/?compare_varietys=${values.compare_varietys}&go_page=${kegg_pages}&go_page_size=${kegg_page_size}`
      )
      .then((res) => {
        setKEGGTotal(res.count);
        let TempleColumsKEGG = [];
        Object.keys(res.results[0]).map((key) => {
          TempleColumsKEGG.push({
            key: key,
            title: key,
            dataIndex: key,
            align: "center",
            render: (index, item) => {
             if(key!='hyperlink'){
              return (
                <p
                  style={{
                    height: "100px",
                    overflow: "auto",
                    display: key != "hyperlink" ? "flex" : "",
                    alignItems: key != "hyperlink" ? "center" : "",
                    justifyContent: key != "hyperlink" ? "center" : "",
                  }}
                >
                  {index}
                </p>
              );
             }else{
              return (
               <Tooltip title={<a href={index} target="_blank">{index}</a>}>
                 <p
                  style={{
                    height: "100px",
                    overflow: "auto",
                    display: key != "hyperlink" ? "flex" : "",
                    alignItems: key != "hyperlink" ? "center" : "",
                    justifyContent: key != "hyperlink" ? "center" : "",
                    cursor: "pointer",
                  }}
                >
                  {index}
                </p>
               </Tooltip>
              );
             }
            },
          });
        });
        setKEGGColumn(TempleColumsKEGG);
        setKEGGTable(res.results);
        setIsSubmitLoading(false);
      })
      .catch((err) => {
        setIsSubmitLoading(false);

      });
  };
  useEffect(() => {
    if (formValues?.compare_varietys) {
      GetKEGGPartII(formValues, KEGGPage, KEGGPageSize);
      setKEGGImgList(methy_DMR_KEGG_paths[formValues.compare_varietys]);
    } else {
      GetKEGGPartII(
        { compare_varietys: defaultVariety },
        KEGGPage,
        KEGGPageSize
      ); // 默认请求数据
      setKEGGImgList(methy_DMR_KEGG_paths[defaultVariety]);
    }
  }, [KEGGPage, KEGGPageSize]);
  const paginationConfigKEGG = {
    current: KEGGPage,
    pageSize: KEGGPageSize,
    total: KEGGTotal,
    showSizeChanger: true,
    pageSizeOptions: ["10", "25", "50", "100"],
    onChange: (page) => {
      setKEGGPage(page);
    },
    onShowSizeChange: (current, size) => {
      setKEGGPageSize(size);
      setKEGGPage(1); // Reset to first page on page size change
    },
  };
  // 表单提交处理函数
  const onFinish = (values) => {
    setFormValues(values); // 更新表单的值
    setIsSubmitLoading(true);

    GetPartII(values, pages, PageSize);
    GetGoPartII(values, GoPage, GoPageSize);
  };
    // 用来存储选中的下拉框值
    const [selectedVariety, setSelectedVariety] = useState(defaultVariety);

    // 当选择下拉框的值变化时触发
    const handleSelectChange = (value) => {
      setSelectedVariety(value);
  
      // 获取选中的值对应的 Tissue 和 Time
      const info = methy_compare_info[value];
  
      // 使用 setFieldsValue 回填表单
      form.setFieldsValue({
        tissue: info ? info.Tissue : "",
        time: info ? info.Time : "",
      });
    };
    useEffect(() => {
      const info = methy_compare_info[defaultVariety];
      if (info) {
        form.setFieldsValue({
          compare_varietys: defaultVariety,
          tissue: info.Tissue,
          time: info.Time,
        });
      }
    }, [form]);
  
  return (
    <div>
      <div className={PartIIStyle.DNA_methylation_search_Form_div2}>
      <Form
      onFinish={onFinish}
      form={form} // 绑定 form 实例
      style={{ width: "90%", margin: "auto" }}
    >
      <Row
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Col span={6}>
          <Form.Item
            label={<span style={{ fontWeight: "bold" }}>Compare varietys</span>}
            name="compare_varietys"
            initialValue={selectedVariety} // 设置默认值
          >
            <Select
              style={{ width: 200 }}
              options={SelectOPtions}
              onChange={handleSelectChange} // 监听下拉框值变化
            />
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item
            label={<span style={{ fontWeight: "bold" }}>Tissue</span>}
            name="tissue"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item
            label={<span style={{ fontWeight: "bold" }}>Time</span>}
            name="time"
          >
            <Input style={{overflow:"auto"}}  />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                background: "#076A09",
                border: "none",
                color: "white",
              }}
              loading={IsSubmitLoading}
            >
              Search DMR
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
      </div>
      <StyledTable
        style={{ width: "95%", margin: "20px auto" }}
        columns={DNA2Colums}
        dataSource={CompareTable}
        bordered
        pagination={paginationConfig}
      />
      <div className={PartIIStyle.DNA_methylation_search2_heatmap}>
        {Object.keys(Part_IIImg).map((key) => {
          return (
            <div
              style={{
                width: "48%",
                height: "49%",
                margin: "10px 0",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ width: "50%", height: "100%" }}>
                <StyledCarousel ref={SwiperRefFn(key)}>
                  {Part_IIImg[key].map((v) => {
                    return (
                      <div key={v} className="carousel-item">
                        <img
                          src={`${v}`}
                          style={{
                            width:"100%",
                            height: "100%",
                            margin: "auto",
                          }}
                          alt={`carousel-${v}`}
                        />
                      </div>
                    );
                  })}
                </StyledCarousel>
              </div>
              <div
                style={{
                  height: "300px",
                  overflow: "auto", // 只允许横向滚动
                  margin: "10px 0",
                  whiteSpace: "nowrap", // 确保图片水平排列
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {Part_IIImg[key].map((v, i) => {
                  return (
                    <img
                      key={i}
                      onClick={() => {
                        if (key === "boxplot") {
                          SwiperBoxPlot.current.goTo(i);
                          setSelectedIndexOne(i);
                        }
                        if (key === "circos") {
                          SwiperCircos.current.goTo(i);
                          setSelectedIndexTwo(i);
                        }
                        if (key === "distribution") {
                          SwiperDistribution.current.goTo(i);
                          setSelectedIndexThree(i);
                        }
                        if (key === "heatmap") {
                          SwiperHeatMap.current.goTo(i);
                          setSelectedIndexFour(i);
                        }
                      }}
                      src={`${v}`}
                      style={{
                        width: "100px", // 设置图片宽度
                        height: "auto",
                        cursor: "pointer",
                        margin: "0 15px",
                        display: "inline-block",
                        border: selectedIndexFn(key, i), // 选中时添加边框
                        transition: "border 0.3s ease-in-out", // 添加过渡效果
                      }}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <div className={PartIIStyle.DNA_methylation_Go}>
        <StyledTable
          style={{ width: "49%", height: "100%" }}
          pagination={paginationConfigGo}
          bordered
          columns={GoColumn}
          dataSource={GoTable}
          scroll={{
            x: 2200,
            y: 290,
          }}
        />
        <div className={PartIIStyle.DNA_methylation_GO_Right}>
          <div style={{ width: "78%", height: "100%" }}>
            <StyledCarousel
              ref={GoSwiperRef}
              style={{ width: "100%", height: "400px" }}
            >
              {GoImgList.map((v, i) => {
                return (
                  <div
                    key={v}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "400px",
                    }}
                    className="carousel-item"
                  >
                    <img
                      src={`${v}`}
                      style={{
                        width: "100%", // 让图片的宽度充满容器
                        height: "100%", // 让图片的高度充满容器
                        objectFit: "cover", // 保持图片比例填充，不会变形
                      }}
                      alt={`carousel-${v}`}
                    />
                  </div>
                );
              })}
            </StyledCarousel>
          </div>
          <div
            style={{
              width: "30%",
              height: "100%",
              overflow: "auto",
              whiteSpace: "nowrap",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {GoImgList.map((v, i) => {
              return (
                <img
                  src={`${v}`}
                  onClick={() => {
                    GoSwiperRef.current.goTo(i);
                    setGoSwiperCurrent(i);
                  }}
                  style={{
                    width: "90%",
                    height: "auto",
                    margin: "10px 0",
                    display: "inline-block",
                    cursor: "pointer",
                    border: GoSwiperChange(i), // 选中时添加边框
                    transition: "border 0.3s ease-in-out", // 添加过渡效果
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
      <div className={PartIIStyle.DNA_methylation_KEGG}>
        <StyledTable
          style={{ width: "49%", height: "100%" }}
          pagination={paginationConfigKEGG}
          bordered
          columns={KEGGColumn}
          dataSource={KEGGTable}
          scroll={{
            x: 2200,
            y: 390,
          }}
        />
        <div className={PartIIStyle.DNA_methylation_KEGG_Right}>
        <div style={{ width: "78%", height: "100%" }}>
            <StyledCarouselKEGG
              ref={KEGGSwiperRef}
              style={{ width: "100%", height: "400px" }}
            >
              {KEGGImgList.map((v, i) => {
                return (
                  <div
                    key={v}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "400px",
                    }}
                    className="carousel-item"
                  >
                    <img
                      src={`${v}`}
                      style={{
                        width: "100%", // 让图片的宽度充满容器
                        height: "100%", // 让图片的高度充满容器
                        objectFit: "cover", // 保持图片比例填充，不会变形
                      }}
                      alt={`carousel-${v}`}
                    />
                  </div>
                );
              })}
            </StyledCarouselKEGG>
          </div>
          <div
            style={{
              width: "30%",
              height: "100%",
              overflow: "auto",
              whiteSpace: "nowrap",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {KEGGImgList.map((v, i) => {
              return (
                <img
                  src={`${v}`}
                  onClick={() => {
                    KEGGSwiperRef.current.goTo(i);
                    setKEGGSwiperCurrent(i);
                  }}
                  style={{
                    width: "90%",
                    height: "auto",
                    margin: "10px 0",
                    display: "inline-block",
                    cursor: "pointer",
                    border: KEGGSwiperChange(i), // 选中时添加边框
                    transition: "border 0.3s ease-in-out", // 添加过渡效果
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Part_II;
